import { cx } from "@linaria/core";
import { FC, memo, ReactNode } from "react";
import { UseShippingsReturnType } from "@/hooks/shippings/types";
import { Button } from "@/ui/Button/Button";
import { cssButtonClean } from "@/ui/Button/StyledButton";
import { Popover } from "@/ui/Popover/Popover";
import { Typography } from "@/ui/Typography/Typography";
import { shippingDateToString } from "@/utils/common/helpers";
import { ActionBar } from "../../ActionBar/ActionBar";
import { ActionBarContainer } from "../../ActionBar/StyledActionBar";
import { cssTooltipDate } from "../StyledProduct";
export type ShippingsBadgesPropsType = Pick<UseShippingsReturnType, "isExpressShipping" | "shippingDate" | "isDateToOnlyCompany">;
export const TooltipSB: FC<{
  text?: ReactNode | string;
}> = ({
  text
}) => {
  return <Popover placement={"bottom-start"} withHover isStylingIconDisclosure={false} offset={[0, 0]} disclosure={<Button variant={"box"} icon={"Help"} className={cx(cssButtonClean)} />} className={cssTooltipDate}>
      <Typography variant={"p13"}>{text}</Typography>
    </Popover>;
};
const ShippingsBadges: FC<ShippingsBadgesPropsType> = memo(({
  isExpressShipping,
  shippingDate,
  isDateToOnlyCompany,
  children
}) => {
  return <ActionBarContainer>
        {children}

        {isExpressShipping && <ActionBar icon={"Taxi"} description={<>
                Быстрая доставка
                <TooltipSB text="Возможна отправка на такси" />
              </>} variant={"red"} />}

        {shippingDate !== null && <ActionBar icon={"Car"} description={<>
                {shippingDateToString(shippingDate)}
                {isDateToOnlyCompany && <TooltipSB text="Указан срок доставки до транспортной компании" />}
              </>} />}
      </ActionBarContainer>;
});
ShippingsBadges.displayName = "ShippingsBadges";
export { ShippingsBadges };